import { FC, useEffect, useState } from "react";
import { I_model, I_role } from "./types";
import AIOInput, { AISelect } from "./../../components/aio/aio-input";
import { useRootFreelancerProvider } from "./context";
import Icon from "@mdi/react";
import { mdiCheckboxBlankOutline, mdiCheckboxMarked, mdiClose } from "@mdi/js";

export const useRoles = () => {
    const { apis, popup } = useRootFreelancerProvider()
    const [allRoles, setAllRoles] = useState<I_role[]>([])
    const fetchAllRoles = async () => {
        const res = await apis.getAllRoles();
        if (res) { setAllRoles(res) }
    }
    useEffect(() => { fetchAllRoles() }, [])
    const openRoleModal = async (row: I_model) => {
        popup.addModal({
            header: { title: 'تخصیص نقش' }, body: (<Role row={row} allRoles={allRoles} />),
            position: 'center',
            bodyAttrs: { className: 'bg-white' },
            modalAttrs: { style: { borderRadius: 12, overflow: 'hidden' } }
        })
    }
    const openHubModal = async (row: I_model) => {
        popup.addModal({
            header: { title: 'محدوده عملیات' }, body: (<Hub row={row} allRoles={allRoles} />),
            position: 'center',
            bodyAttrs: { className: 'bg-white' },
            modalAttrs: { style: { borderRadius: 12, overflow: 'hidden' } }
        })
    }
    return { openRoleModal, openHubModal }
}

export const Role: FC<{ row: I_model, allRoles: I_role[] }> = ({ row, allRoles }) => {
    const { apis, popup } = useRootFreelancerProvider();
    const [roleIds, setRoleIds] = useState<number[]>([])
    const fetchRoleIds = async () => {
        const res = await apis.getRoleIds(row.id)
        if (res) { setRoleIds(res) }
    }
    useEffect(() => {
        fetchRoleIds();
    }, [])
    const submit = async () => {
        const res = await apis.changeRoles(row.id, roleIds)
        if (res) { popup.removeModal() }
    }
    return (
        <div className="flex flex-col p-4 gap-4 w-[300px]">
            <div className="p-2">{`نام پرسنل : ${row.name}`}</div>
            <AISelect
                options={allRoles} multiple={true} text='انتخاب نقش' search='جستجوی نقش'
                className='rounded-lg'
                option={{
                    text: (o) => o.text,
                    value: (o) => o.id
                }}
                value={roleIds}
                onChange={(newRoleIds) => setRoleIds(newRoleIds)}
            />
            <div className="flex flex-row gap-2">
                <button type='button' className="freelancer-primary-button flex-1" onClick={submit}>تایید</button>
                <button type='button' className="freelancer-secondary-button flex-1" onClick={() => popup.removeModal()}>خروج</button>
            </div>
        </div>
    )
}
export const Hub: FC<{ row: I_model, allRoles: I_role[] }> = ({ row, allRoles }) => {
    const { apis, popup } = useRootFreelancerProvider();
    const [selectedHubs, setSelectedHubs] = useState<{text:string,id:number}[]>([])
    const fetchHubIds = async () => {
        const res = await apis.getHubIds(row.id)
        if (res) { setSelectedHubs(res) }
    }
    useEffect(() => {
        fetchHubIds();
    }, [])
    const submit = async () => {
        const res = await apis.changeHubs(row.id, selectedHubs.map(((o)=>o.id)))
        if (res) { popup.removeModal() }
    }
    const remove = (id:number)=>setSelectedHubs((prev)=>prev.filter((o)=>o.id !== id))
    return (
        <div className="flex flex-col p-4 gap-4 w-[300px]">
            <div className="p-2">{`نام پرسنل : ${row.name}`}</div>
            <div className="max-h-[300px] overflow-y-auto">
                <HubTree
                    selected={selectedHubs}
                    onChange={(v) => setSelectedHubs(v)}

                />
            </div>
            <div className="flex flex-row flex-wrap gap-1">
                {
                    selectedHubs.map((o)=>{
                        return (
                            <div className="rounded-md p-2 bg-[#ddd] flex flex-row items-center gap-1 cursor-pointer" onClick={()=>remove(o.id)}>{o.text}<Icon path={mdiClose} size={0.6}/></div>
                        )
                    })
                }
            </div>
            <div className="flex flex-row gap-2">
                <button type='button' className="freelancer-primary-button flex-1" onClick={submit}>تایید</button>
                <button type='button' className="freelancer-secondary-button flex-1" onClick={() => popup.removeModal()}>خروج</button>
            </div>
        </div>
    )
}


export const HubTree: FC<{
    selected: {id:number,text:string}[]; style?: any;
    onChange: (newValue: {text:string,id:number}[]) => void;
}> = ({selected,onChange}) => {
    const hublist = JSON.parse(localStorage.getItem('hublist'))
    return (
        <AIOInput
            type="tree"
            rtl={true}
            value={hublist}
            option={{
                childs: (o) => {
                    const childs = o.children;
                    return childs === null ? [] : childs;
                },
                checkIcon: () => [
                    <Icon path={mdiCheckboxBlankOutline} size={0.6} color='#ef5644' />,
                    <Icon path={mdiCheckboxMarked} size={0.6} color='#ef5644' />
                ],
                text: (option) => option.label,
                value: (option) => option.id,
                checked: (option) => selected.some((o) => o.id === option.id),
                onClick: (option) => {
                    let newValue: {text:string,id:number}[] = [];
                    const isChecked = selected.some((o) => o.id === option.id);
                    if (!isChecked) {newValue = [...selected,{text:option.label,id:option.id}];} 
                    else {newValue = selected.filter((o) => o.id !== option.id);}
                    onChange([...newValue])
                },
            }}
        />
    );
};
